/**
 * 推送消息接收后的业务处理（项目定制层）
 * App 在前台收到透传消息(receive)时，插件会按 payload.type 分发到这里对应的处理器；
 * 新增业务类型时，在 receiveHandlers 中加一个 key 即可
 */
import type { PushReceiveHandler } from '@/plugins/uni-push';
import { usePushStore } from '@/store';

/**
 * 透传消息按业务类型分发的处理器表（key = payload.type）
 * 注意：handler 内部再取 store，避免模块加载时机导致 pinia 未激活
 */
export const receiveHandlers: Record<string, PushReceiveHandler> = {
  // 聊天消息：更新未读数（角标随 store 同步）
  chat: (data, msg) => {
    const store = usePushStore();
    store.updateUnreadCount(1, data?.type);
    console.log('[Push Handlers] chat 透传已处理 | data =', data, '| 消息 =', msg, '| 未读数 =', store.unreadCount);
  },

  // 系统通知：更新未读数，可扩展存入本地通知列表
  system: (data, msg) => {
    const store = usePushStore();
    store.updateUnreadCount(1, data?.type);
    console.log('[Push Handlers] system 透传已处理 | data =', data, '| 消息 =', msg, '| 未读数 =', store.unreadCount);
  },

  // 订单消息：可触发刷新订单列表（如通过 uni.$emit 通知页面）
  order: (data, msg) => {
    console.log('[Push Handlers] order 透传已处理 | data =', data, '| 消息 =', msg);
    // uni.$emit('push:order', data);
  },
};

/**
 * 兜底处理：无 payload 或未匹配到 receiveHandlers 的透传消息
 * 能看到这条日志说明透传已正常送达，只是 type 未在上方登记
 */
export const onReceive: PushReceiveHandler = (data, msg) => {
  console.warn(`[Push Handlers] 透传已送达但无对应处理器: type = ${data?.type ?? '(无)'}`, '| data =', data, '| 消息 =', msg);
};
